import { useParams } from "react-router-dom";
import RuleEditor from "./RuleEditor";

export default function RuleEditPage() {
  const { id } = useParams();
  return <RuleEditor mode="edit" ruleId={id} />;
}